import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/home-mobile';

const HomeRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/HomeMobile')),
    name: 'Home',
};

export default HomeRoute;
